import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(id, startDate) {
  return yield oncallFetch("/api/oncall/partners/shifts-definitions/move", {
    id,
    startDate,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/shifts-definitions/move.js